// extracted by mini-css-extract-plugin
export default {"displayText":"add-landing-page-modal__display-text__rmfSe"};